<div class="d-flex align-items-center s-mb-2">
  <!-- <h1>Bem-vindo ao ID Banco Digital!</h1> -->

  <!-- <button
    class="d-inline-flex align-items-center s-pe-2 s-me-1 border-0 bg-transparent"
  >
    <mat-icon (click)="navigateBack()" color="accent"> arrow_back </mat-icon>
  </button> -->
  <ng-container
    *ngFor="
      let breadcrumb of breadcrumbList$ | async;
      index as i;
      last as isLast
    "
  >
    <span
      role="button"
      [routerLink]="breadcrumb.path"
      [class]="isLast ? 'fs-5 text-decoration-underline fw-bold' : 'fs-5'"
    >
      {{ breadcrumb.label }}
    </span>
    <span *ngIf="!isLast" class="s-mx-3">›</span>
  </ng-container>
</div>
